<template>
  <div class="auth-container">
    <el-dialog :lock-scroll="true" v-if="globalDialog.forgetPwdVisible" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="globalDialog.forgetPwdVisible">
      <ForgetPwd :isDialog="true" v-on:success="close" class="passport-dialog"></ForgetPwd>
    </el-dialog>
  </div>
</template>

<script>
import ForgetPwd from './ForgetPwd'

export default {
  name: 'ForgetPwdDialog',
  components: {
    ForgetPwd: ForgetPwd
  },
  computed: {
    globalDialog () {
	    return this.$store.state.globalDialog
    }
  },
  data () {
    return {
    }
  },
  created() {
  },
  methods: {
    close () {
      this.$store.commit('hideGlobalDialog', 'forgetPwdVisible')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/passport/ForgetPwdDialog.vue